import { Tag } from 'antd';
import { MEDIA_OFFER_DECIDER } from 'hooks/useMediaOfferPermission';

/**
 * @description BE `decisionMaker` (decider) rolü → "Birim" kolonu rozeti (Türkçe etiket + antd preset rengi).
 * Anahtarlar `MEDIA_OFFER_DECIDER` ile birebir aynı OLMALI (tek doğruluk kaynağı); etiketler
 * `STATUS_DECIDER_MAP`'teki statü adlarıyla hizalıdır (bkz. useMediaOfferPermission §1.5).
 * Renkler antd preset paletinden; `red` projede "Uygun Değildir" kararına ayrılmış olduğu için kullanılmaz.
 * @type {Record<string, { label: string, color: string }>}
 */
export const DECISION_MAKER_BADGE = {
  [MEDIA_OFFER_DECIDER.author]: { label: 'Yazar', color: 'green' },
  [MEDIA_OFFER_DECIDER.ihControl]: { label: 'İH - Madde Kontrol', color: 'geekblue' },
  [MEDIA_OFFER_DECIDER.ihControlTranslate]: { label: 'İH - Tercüme', color: 'geekblue' },
  [MEDIA_OFFER_DECIDER.supervisor]: { label: 'Madde Sorumlusu (İlim Heyeti)', color: 'blue' },
  [MEDIA_OFFER_DECIDER.postOrderMediaOfferControl]: { label: 'AB - Medya Teklifi Kontrolü', color: 'purple' },
  [MEDIA_OFFER_DECIDER.postOrderEuControl]: { label: 'Ansiklopedi Birimi Kontrol', color: 'cyan' },
  [MEDIA_OFFER_DECIDER.postOrderOwnerCommitteeControl]: { label: 'TS - İH Madde Kontrol', color: 'magenta' },
  [MEDIA_OFFER_DECIDER.postOrderSupervisor]: { label: 'TS - Madde Sorumlusu Kontrol', color: 'gold' },
  [MEDIA_OFFER_DECIDER.postOrderPubControl]: { label: 'Yayın Müdürlüğü Genel Kontrol', color: 'volcano' },
  [MEDIA_OFFER_DECIDER.postOrderCitationSourceRedaction]: { label: 'YM - Atıf-Kaynaklar Redaksiyonu', color: 'yellow' },
  [MEDIA_OFFER_DECIDER.postOrderTranslationTextRedaction]: { label: 'YM - Çeviri-Yazı Redaksiyonu', color: 'pink' },
  [MEDIA_OFFER_DECIDER.postOrderOrthographyRedaction]: { label: 'YM - İmla Redaksiyonu', color: 'lime' },
  [MEDIA_OFFER_DECIDER.postOrderProofreadingControl]: { label: 'YM - Editöryal Son Okuma', color: 'orange' },
};

/**
 * @description "Birim" kolonu rozeti: `decisionMaker` rolünü Türkçe etiket + tipe özel renkle Tag olarak basar.
 * Eşleşme yoksa (henüz bağlanmamış roller) boş Tag yerine hiçbir şey render etmez.
 * @param {Object} props
 * @param {string} [props.text] BE `decisionMaker` değeri (`MEDIA_OFFER_DECIDER` değerlerinden biri).
 */
function DecisionMakerBadge({ text }) {
  const badge = DECISION_MAKER_BADGE[text];
  if (!badge) return null;
  // Uzun roller (ör. "Yayın Müdürlüğü Genel Kontrol") dar "Birim" kolonuna sığmayıp kırpılıyordu.
  // antd Tag varsayılan tek satır (white-space:nowrap) olduğu için etiketi çok satıra saralım:
  // hücre genişliğini aşmaz (maxWidth:100%), tamamı her zaman okunur, hover gerekmez.
  return (
    <Tag
      color={badge.color}
      style={{ whiteSpace: 'normal', height: 'auto', maxWidth: '100%', wordBreak: 'break-word' }}
    >
      {badge.label}
    </Tag>
  );
}
export default DecisionMakerBadge;
